import UnitedKingdom from '../assets/images/survey/flags/Flag_of_the_United_Kingdom.svg.png';
import IndiaFlag from '../assets/images/survey/flags/Flag_of_India.svg.png';
import IranFlag from '../assets/images/survey/flags/Flag_of_Iran.svg.png';
import PakistanFlag from '../assets/images/survey/flags/Flag_of_Pakistan.svg.png';
import PolandFlag from '../assets/images/survey/flags/Flag_of_Poland.svg.png';
import RomaniaFlag from '../assets/images/survey/flags/Flag_of_Romania.svg.png';
import SaudiArabiaFlag from '../assets/images/survey/flags/Flag_of_Saudi_Arabia.svg.png';
import HongKongFlag from '../assets/images/survey/flags/Flag_of_Hong_Kong.svg.png';
import BangladeshFlag from '../assets/images/survey/flags/Flag_of_Bangladesh.svg.png';

export const LanguagesOptions = [
    {
        code: 'en',
        nativeName: 'English',
        flag: UnitedKingdom
    },
    {
        code: 'ar',
        nativeName: 'Arabic',
        flag: SaudiArabiaFlag
    },
    {
        code: 'bn',
        nativeName: 'Bengali',
        flag: BangladeshFlag
    },
    {
        code: 'zh-hant',
        nativeName: 'Cantonese',
        flag: HongKongFlag
    },
    {
        code: 'fa',
        nativeName: 'Farsi',
        flag: IranFlag
    },
    {
        code: 'hi',
        nativeName: 'Gujarati',
        flag: IndiaFlag
    },
    {
        code: 'pl',
        nativeName: 'Polish',
        flag: PolandFlag
    },
    {
        code: 'pa',
        nativeName: 'Punjabi',
        flag: PakistanFlag
    },
    {
        code: 'ro',
        nativeName: 'Romanian',
        flag: RomaniaFlag
    },
    {
        code: 'ur',
        nativeName: 'Urdu',
        flag: PakistanFlag
    }
];
